export default "__VITE_ASSET__bdc7fa98__"